<template>
  <v-row>
    <!-- Start Blog Area  -->
    <v-col
        lg="4"
        md="4"
        sm="6"
        cols="12"
        v-for="(item, i) in blogContent"
        :key="i"
    >
      <div class="blog blog-style--1">
        <div class="thumbnail">
          <router-link :to="`/blog/${item.slug}`">
            <img class="w-100" :src="item.src" alt="Blog Images" />
          </router-link>
        </div>
        <div class="content">
          <p class="blogtype">{{ item.meta }}</p>
          <h4 class="heading-title">
            <router-link :to="`/blog/${item.slug}`">{{ item.title }}</router-link>
          </h4>
          <div class="blog-btn">
            <router-link :to="`/blog/${item.slug}`" class="rn-btn white--text">
              Leer más
            </router-link>
          </div>
        </div>
      </div>
    </v-col>
    <!-- End Blog Area  -->
  </v-row>
</template>

<script>
import {container} from "@/main";
import {PostsService} from "@/pages/blog/posts.service";

export default {
  props: ['relatedPosts'],
  methods: {
    decodeHtml(html) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      return textarea.value;
    },
    async renderRelatedPost() {
      this.blogContent = [];
      this.postService = container.get(PostsService);
      for(const post of this.relatedPosts) {
        const postData = await this.postService.getPostDetailById(post.id);
        this.blogContent.push({
          src: post.img.src,
          meta: this.decodeHtml(post.context),
          title: post.title,
          link: post.url,
          slug: postData.slug
        });
      }
    }
  },
  async created() {
    await this.renderRelatedPost();
  },
  data() {
    return {
      postService: null,
      blogContent: [
        {
          src: require("../../../assets/images/blog/blog-01.jpg"),
          meta: "Development",
          title: "Getting tickets to the big show",
          link: "Getting tickets to the big show",
        },
        {
          src: require("../../../assets/images/blog/blog-02.jpg"),
          meta: "Development",
          title: "Getting tickets to the big show",
          link: "Getting tickets to the big show",
        },
        {
          src: require("../../../assets/images/blog/blog-03.jpg"),
          meta: "Development",
          title: "Getting tickets to the big show",
          link: "Getting tickets to the big show",
        },
      ],
    };
  },
};
</script>
